export default "__VITE_ASSET__Cs1eV3CD__"